import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import IconButton from '../iconButton';
import icons from '../../assets/icons';
import { getIsPortalPreview, getSelectedPortal, stopPortalPreview } from '../../redux/portal/actions';
import { setLoading } from '../../redux/dashboard/actions';
import '../impersonateFrame/styles.scss';

const PortalPreviewIndicator = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const isPortalPreview = useSelector(getIsPortalPreview);
  const portal = useSelector(getSelectedPortal);

  if (!isPortalPreview) return null;

  const exitPreview = () => {
    dispatch(setLoading(true));
    dispatch(stopPortalPreview());
    history.replace('/portals');
    window.requestAnimationFrame(() => dispatch(setLoading(false)));
  };

  return (
    <div
      className="impersonate-mode portal-preview-mode"
      role="status"
      aria-label={`Previewing ${portal?.displayName || 'portal'}`}
    >
      <div>
        <div className="imp-border top" />
        <div className="imp-border right" />
        <div className="imp-border bottom" />
        <div className="imp-border left" />

        <div className="imp-tools">
          <img className="eyes-icon" src={icons.impersonateEye} alt="" />
          <span className="impersonating-name">Viewing {portal?.displayName || 'Portal'}</span>
          <IconButton
            id="leave-portal-preview"
            icon="leave"
            ariaLabel="Exit preview"
            onPress={exitPreview}
          />
        </div>
      </div>
    </div>
  );
};

export default PortalPreviewIndicator;
